<div class="top-banner">
  <div class="top-banner-title" *ngIf="type === 'info'">{{ 'PROJECT_PAGE.about_projectpage' | translate }} {{ name }}</div>
  <div class="top-banner-title" *ngIf="type === 'standards'">{{ 'PROJECT_PAGE.standards2_projectpage' | translate }}</div>
  <div class="close-button" (click)="closeDialog()">
    <img src="assets/icons/cross-dark-blue.svg" alt="close">
  </div>
</div>
<div class="img-wrapper" *ngIf="type === 'info'">
  <img [src]="logo" class="logo" alt="logo">
</div>
<div class="content-wrapper" *ngIf="type === 'info'">
  <div class="additional-data" *ngFor="let additional_data of additionalData">
    <div class="additional-data-name">{{ additional_data.name[currentLanguage] }}</div>
    <div class="additional-data-value" [innerHTML]="additional_data.value[currentLanguage]"></div>
  </div>
  <div class="website-title" *ngIf="website">{{ 'PROJECT_PAGE.website_projectpage' | translate }}</div>
  <div class="website-content" *ngIf="website"><a [href]="website[currentLanguage]" target="_blank">{{ website[currentLanguage] }}</a></div>
  <div class="mission-title">{{ 'PROJECT_PAGE.mission_projectpage' | translate }}</div>
  <div class="mission-content" [innerHTML]="description[currentLanguage]"></div>
</div>
<div class="standards-title" *ngIf="type === 'standards'">{{ 'PROJECT_PAGE.standards3_projectpage' | translate }}</div>
<div class="standards-wrapper" *ngIf="type === 'standards'">
  <div class="standard" *ngFor="let standard of standards">
    <img [src]="standard" alt="standards">
  </div>
</div>
